const PlayIcon = ({ width = 95, height = 95 }) => <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 95 95">
  <path fill="#fff" d="M65.224 48.209 38.638 71.54V24.878l26.586 23.331Z" />
  <circle cx="47.5" cy="47.5" r="45" stroke="#fff" stroke-width="5" />
</svg>



export default PlayIcon;
